export default __webpack_public_path__ + "static/press_2_orig-669a6a2f78d3e5783c4d5087d8b9f24d.png";